<template>
    <main class="container main">      
      <div class="card card-title">
        <h3>Q{{ $props.q }} : <u>{{ getQText($props.level, parseInt($props.q)-1) }}</u></h3>
        <h4>青い文字をクリックしてリンク先のページにアクセスできます</h4>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card" style="background: rgba(250, 250, 250, 0.8);" 
                v-bind:class="{'card-outline-warning': item.recommend}"  v-for="(item, i) in links" :key="i">
              <h3 class="card-header">
                <img v-if="item.recommend" class="img-responsive" 
                    src="../assets/picks.png" align="left"> &nbsp; {{ item.type }} : <a :href="item.url" target="_blank">{{ item.name }}</a>
              </h3>
              <div class="card-block">
                <h3>{{ item.overview }}</h3>
                <h4 class="text-right">提供元 : {{ item.source }} </h4>
              </div>
            </div>
        </div>
      </div>
    </main>
</template>

<script>
import axios from 'axios'

export default {
    data: function() {
        return {
            /* リンク先のデータ */
            links: null,
        }
    },
    props: [
        'level',
        'q',
    ],
    created: function() {
        const filename = "../../static/" + this.$props.level + "/content.json";
        this.loadCSV();
    },
    methods: {
        /* csvを読み込み */
        loadCSV: function() {
            const filename = "../../static/" + this.$props.level + '/linkfile/q'+ this.$props.q + '.csv';
            axios({
                url: filename,
                method: 'GET',
            }).then((response) => {
                this.links = this.transformCSV(response.data);
            }).catch(error => {
                console.error(error);
            });
        },
        /* csvString形式からWebで表示できる形式に変換する */
        transformCSV: function(csvString) {
            // sliceで1行目を削除
            // filterで空行を削除
            // mapで配列の各行を変換
            return csvString.split('\n').slice(1).filter((row) => row.length > 0).map((row) => {
                const array = row.split(',');
                return {
                    type: array[0],
                    name: array[1],
                    url: array[2],
                    overview: array[3],
                    source: array[4],
                    recommend: array[5] === "1",
                }
            });
        }
    }
}
</script>

<style>

/* card関連 */
.card {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
      -ms-flex-direction: column;
          flex-direction: column;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  margin-top: 20px;
}


.card-title{
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 15px;
  background: rgba(230,230,250,0.8);
}

.card-block {
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}


</style>